// OP1WebWindow: a copy of OP1WebAW designed in Plasmic. Same window
// behaviour as OP1WebAW, shared from appWindowBehavior.jsx.
// This file is owned by us: `plasmic sync` never overwrites it.
import { PlasmicOp1WebWindow } from "./plasmic/one_platform/PlasmicOp1WebWindow";
import { createAppWindow } from "./appWindowBehavior";

const Op1WebWindow = createAppWindow(PlasmicOp1WebWindow, "Op1WebWindow");

export default Op1WebWindow;
